import { render, staticRenderFns } from "./RoleSelect.vue?vue&type=template&id=613d5ebb&scoped=true"
import script from "./RoleSelect.vue?vue&type=script&lang=js"
export * from "./RoleSelect.vue?vue&type=script&lang=js"
import style0 from "./RoleSelect.vue?vue&type=style&index=0&id=613d5ebb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613d5ebb",
  null
  
)

export default component.exports